var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 20.0001H19.1106M6.36953 13.0554C5.99053 13.4352 5.77764 13.9499 5.77754 14.4864V17.3335H8.64238C9.17926 17.3335 9.69392 17.1202 10.0735 16.7397L18.5178 8.29101C18.8966 7.9111 19.1094 7.39646 19.1094 6.85992C19.1094 6.32339 18.8966 5.80874 18.5178 5.42884L17.684 4.5933C17.496 4.40517 17.2727 4.25595 17.0269 4.15417C16.7812 4.05239 16.5178 4.00004 16.2518 4.00012C15.9858 4.0002 15.7225 4.05271 15.4768 4.15465C15.2311 4.25658 15.008 4.40594 14.82 4.59419L6.36953 13.0554Z",
    stroke: "#875FFE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit24Px);
export default __webpack_public_path__ + "static/media/Edit_24px.3d1030ac6e5808a4553a5f447286a6f7.svg";
export { ForwardRef as ReactComponent };